// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  reviewListRequest: ['filter'],
  reviewListSuccess: ['data'],
  reviewListFailure: ['err'],

  reviewApproveRequest: ['id'],
  reviewApproveSuccess: null,
  reviewApproveFailure: ['err']
})

export const ReviewTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: {
    list: []
  },
  err: null,
  processing: false,
  success: null,
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({ fetching: true, success: null})

export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null
  })

export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null, err: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.REVIEW_LIST_SUCCESS]: success,
  [Types.REVIEW_LIST_REQUEST]: request,
  [Types.REVIEW_LIST_FAILURE]: failure,

  [Types.REVIEW_APPROVE_SUCCESS]: manipulateSuccess,
  [Types.REVIEW_APPROVE_REQUEST]: manipulateRequest,
  [Types.REVIEW_APPROVE_FAILURE]: manipulateFailure,
})



// WEBPACK FOOTER //
// ./src/Redux/ReviewRedux.js